import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useHistory } from 'react-router-dom';
import { Alert, BlankState, Button, Card, Divider, Link, SectionHeader } from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { TimeWindow } from '../../api/candidate/resit/@coordinator/api-services/models';
import RouteKey from '../../routes/key';

import {typeTheme} from "web-library/theme/helper/tssHelper"
const { resit } = RouteKey.child;
const { listing } = RouteKey.resit.child;

const useStyles = makeStyles()((theme) =>
({
  alert: {
    marginBottom: theme.spacing(3.5),
  },
  card: {
    padding: theme.spacing(5),
  },
  backButton: {
    color: theme.color.link.linkDefault01,
  },
  linkAlert: {
     ...typeTheme(theme, 'buttonSmall'),
  },
}));

export interface WindowPeriodInformationProps {
  timeWindow?: TimeWindow;
  page: 'candidate' | 'coordinator';
  eligibleErrorCode?: string;
  eligibleErrorData?: string;
}

const WindowPeriodInformation: React.FC<WindowPeriodInformationProps> = (
  props: WindowPeriodInformationProps
) => {
  const {
    timeWindow,
    page,
    eligibleErrorData,
    eligibleErrorCode,
    // examSeries, content,
  } = props;
  const { classes } = useStyles();
  const history = useHistory();

  if (page === 'candidate') {
    return (
      <>
        <SectionHeader title="Examinations" />

        {eligibleErrorData && !timeWindow && (
          <Alert
            message={
              <>
                {`${eligibleErrorData} `}
                {eligibleErrorCode === '5001' && (
                  <Button
                    onClick={() => history.push(`/${resit}/${listing.route}`)}
                    className={classes.linkAlert}
                    // contrast
                    variant='text'
                  >
                    View registered exams
                  </Button>
                )}
              </>
            }
            severity={eligibleErrorCode === '5002' ? 'error' : 'info'}
            variant="filled"
            iconName={IconName.info}
            iconSize="M"
            style={{ marginBottom: 24 }}
          />
        )}

        <Card className={classes.card}>
          <BlankState
            label={
              !timeWindow
                ? 'Application for the resit is unavailable.'
                : 'Application for the resit of Mother Tongue Examination is unavailable.'
            }
            HelperComponent={
              <Button
                className={classes.backButton}
                variant="text"
                onClick={() => history.push('/')}
              >
                Back to Homepage
              </Button>
            }
          />
        </Card>
      </>
    );
  }

  return (
    <>
      <Divider />
      <Alert
        className={classes.alert}
        message="Application for the resit of Mother Tongue examination is currently unavailable."
        variant="filled"
        severity="info"
        iconName={IconName.info}
        iconSize="M"
      />
    </>
  );
};
export default WindowPeriodInformation;
